import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth, setPersistence, browserLocalPersistence } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";

export const firebaseConfig = {
  apiKey: "AIzaSyARp63T1RSGDAiZqSG1xhY7mjhZfiuMYUI",
  authDomain: "energy-guru-80eec.firebaseapp.com",
  projectId: "energy-guru-80eec",
  storageBucket: "energy-guru-80eec.appspot.com",
  messagingSenderId: "75036848507",
  appId: "1:75036848507:web:945e4c4a1dd779e5138dde",
  measurementId: "G-HGY34F93YD"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);

// Set persistence to LOCAL (persists even after browser restart)
setPersistence(auth, browserLocalPersistence)
  .catch((error) => {
    console.error("Auth persistence error:", error);
  });

const storage = getStorage(app);
const functions = getFunctions(app);

// GA4 via gtag.js (loaded in index.html for this site's own property
// G-HGY34F93YD, with send_page_view:false so the SPA controls page_view).
// We route events through gtag rather than Firebase Analytics so they land in
// THIS site's GA4 property instead of the Firebase project's default property.
declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
    dataLayer?: unknown[];
  }
}

const analytics = typeof window !== "undefined";
const logEvent = (
  _analytics: unknown,
  eventName: string,
  params?: Record<string, unknown>
): void => {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag("event", eventName, params || {});
  }
};

// Analytics event tracking functions
export const trackPageView = (pageName: string) => {
  if (analytics) {
    logEvent(analytics, 'page_view', {
      page_title: pageName,
      page_location: window.location.href,
      page_path: window.location.pathname
    });
  }
};

export const trackBlogView = (postId: string, postTitle: string) => {
  if (analytics) {
    logEvent(analytics, 'blog_view', {
      post_id: postId,
      post_title: postTitle
    });
  }
};

export const trackQuoteRequest = (source: string) => {
  if (analytics) {
    logEvent(analytics, 'quote_request', {
      source: source
    });
  }
};

// GA4 standard conversion event — a completed, contactable lead.
export const trackLead = (form: string, params: Record<string, unknown> = {}) => {
  if (analytics) {
    logEvent(analytics, 'generate_lead', { form, ...params });
  }
};

export const trackFormStep = (form: string, step: number) => {
  if (analytics) {
    logEvent(analytics, 'form_step', { form, step });
  }
};

export const trackStateDetection = (state: string) => {
  if (analytics) {
    logEvent(analytics, 'state_detected', {
      state: state
    });
  }
};

export const trackCategorySelect = (category: string) => {
  if (analytics) {
    logEvent(analytics, 'category_select', {
      category: category
    });
  }
};

export { db, auth, storage, functions };
